@import "../../globalStyles/commons";

:host {
  display: block;
  padding-bottom: v(--spacing-03);
}

.card {
  display: flex;
  flex-direction: column;
  border: 1px solid v(--border-subtle);
  border-radius: v(--border-radius);
  height: 100%;
  background-color: v(--background);
}

:host([shadow-level="xxl"]) .card {
  box-shadow: v(--shadow-xl);
}

:host([shadow-level="xl"]) .card {
  box-shadow: v(--shadow-xl);
}

:host([shadow-level="lg"]) .card {
  box-shadow: v(--shadow-xl);
}

:host([shadow-level="md"]) .card {
  box-shadow: v(--shadow-xl);
}

:host([shadow-level="sm"]) .card {
  box-shadow: v(--shadow-xl);
}


:host([shadow-level="xs"]) .card {
  box-shadow: v(--shadow-xl);
}

slot::slotted(goat-card-content) {
  display: block;
  padding: 1rem;
  border-bottom: 1px solid v(--border-subtle);
}

slot::slotted(goat-card-content.no-padding) {
  padding: 0;
}

slot::slotted(goat-card-content:last-child) {
  border-bottom: none;
  flex: 1;
}
